import { Chip as MuiChip, chipClasses } from "@mui/material";
import { withDisplayName } from "../../utils/displayName";

const Chip = withDisplayName(MuiChip, "Chip");
export { Chip as default, chipClasses };
export type { ChipProps } from "@mui/material";

declare module "@mui/material/Chip" {
  interface ChipPropsColorOverrides {
    neutral: true;
  }

  interface ChipPropsVariantOverrides {
    block: true;
  }
}

export const ChipColors = [
  "default",
  "neutral",
  "primary",
  "secondary",
  "error",
  "warning",
  "info",
  "success",
] as const;
export type ChipColor = (typeof ChipColors)[number];

export const ChipSizes = ["small", "medium"] as const;
export type ChipSize = (typeof ChipSizes)[number];

export const ChipVariants = ["block", "filled", "outlined"] as const;
export type ChipVariant = (typeof ChipVariants)[number];
